import { Box, Typography } from "../../imports/muiImport";
import { Container } from "@mui/system";
import useEmblaCarousel from 'embla-carousel-react';
import WheelGesturesPlugin from 'embla-carousel-wheel-gestures';
import { useSelector } from "react-redux";
import { NavLink } from "react-router-dom";


const FashionFlexComponent = () => {
  const FashioFlexData = useSelector((state) => state?.Dashboard?.FashionFlex)

  const [emblaRef] = useEmblaCarousel(
    {
      align: 'start',
      dragFree: false,
      slidesToScroll: 1,
      containScroll: 'trimSnaps',
    },
    [WheelGesturesPlugin()]
  );

   const link = (slug) => ({
    pathname: `/card-details/${slug}`,

  });

  return (
    <Container maxWidth={false} disableGutters>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 1.8,
          px: 0.5,
          textTransform: "capitalize",
          color: "#002865",
        }}
      >
        <Typography
          sx={{
            fontSize: { xs: "16px", sm: "24px", md: "30px" },
            fontWeight: 600,
            fontFamily: "Be Vietnam Pro",
          }}
        >
          {FashioFlexData?.title}
        </Typography>
      </Box>


      <Box
        ref={emblaRef}
        sx={{
          overflow: "hidden",
          width: "100%",
        }}
      >

        <Box
          sx={{
            display: "flex",
          }}
        >
          {FashioFlexData?.data?.map((item) => (
            <Box
             component={NavLink}
             to={link(item?.slug)}
              key={item.slug}
              sx={{
                flex: {
                  xs: "0 0 42%",
                  sm: "0 0 32%",
                  md: "0 0 24%",
                  lg: "0 0 20%",
                  xl: "0 0 16%",
                },
                minWidth: 0,
              }}
            >
              {/* CARD */}
              <Box
                sx={{
                  width: "100%",
                  overflow: "hidden",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Box
                  component="img"
                  src={item.image}
                  alt={item.name}
                  sx={{
                    width: "100%",
                    height: "100%",
                    borderRadius: { xs: 3, md: 5 },
                    objectFit: "cover",
                    padding: {
                      xs: "3.5px",
                      sm: "6px",
                      md: "7px",
                      lg: "8px",
                    },
                  }}
                />
              </Box>



            </Box>
          ))}
        </Box>
      </Box>
    </Container>

  );
};

export default FashionFlexComponent;